export const setBottleSales = (reportsData, bottleSalesMap) => {
  reportsData.map((tallyObject) => {
    return bottleSalesMap.set(
      { clientName: tallyObject.name, totalRevenue: tallyObject.totalRevenue },
      tallyObject
    );
  });
};
